﻿//Jquery
import "./jquery-global.js";
import $, {ajax} from "jquery";

import blockui from "block-ui";

export function loaderShow(selector) {
    if (selector && selector.length) {
        let extraClass = "";
        if ($(selector).is("body")) {
            $(selector).css("height", "100vh");
            $(selector).addClass("overflow-hidden");

            if (window.innerWidth > 1200) {
                extraClass = "w-5";
            } else if (window.innerWidth > 992) {
                extraClass = "w-10";
            } else if (window.innerWidth > 768) {
                extraClass = "w-15";
            }
        }


        $(selector).block({
            message: '<svg version="1.1" id="L9" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 100 100" enable-background="new 0 0 0 0" xml:space="preserve"> <path fill="#c00d0e" d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50"> <animateTransform attributeName="transform" attributeType="XML" type="rotate" dur="1s" from="0 50 50" to="360 50 50" repeatCount="indefinite"></animateTransform> </path></svg>',
            overlayCSS: {
                background: 'rgba(0, 0, 0, .3)', opacity: 1, cursor: 'wait'
            },
            blockMsgClass: 'border-0 bg-transparent ' + extraClass
        });
    }
}

export function loaderHide(selector, callback = function () {
}) {
    if ($(selector).is("body")) {
        $(selector).css("height", "auto");
        $(selector).removeClass("overflow-hidden");
    }
    $(selector).unblock();
   
    callback();
}